export const formatSlipDateTime = (iso: string): string => {
  if (Number.isNaN(Date.parse(iso))) return '--';
  return new Intl.DateTimeFormat('he-IL-u-nu-latn', {
    timeZone: 'Asia/Jerusalem',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(iso));
};
